/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sharereviewcolumntime3Inputs */

const en_sharereviewcolumntime3 = /** @type {(inputs: Sharereviewcolumntime3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Time`)
};

const de_sharereviewcolumntime3 = /** @type {(inputs: Sharereviewcolumntime3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeit`)
};

/**
* | output |
* | --- |
* | "Time" |
*
* @param {Sharereviewcolumntime3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const sharereviewcolumntime3 = /** @type {((inputs?: Sharereviewcolumntime3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sharereviewcolumntime3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sharereviewcolumntime3(inputs)
	return de_sharereviewcolumntime3(inputs)
});
export { sharereviewcolumntime3 as "shareReviewColumnTime" }